import { ORDER_STATUS_VARIANTS, TAG_LABEL_VARIANTS } from "./tokens";

export function normalizeStatusKey(status) {
  return String(status || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, " ");
}

export function getOrderStatusVariant(status) {
  const key = normalizeStatusKey(status);
  return ORDER_STATUS_VARIANTS[key] || "neutral";
}

export function getTagVariantFromLabel(label) {
  const key = String(label || "").trim().toLowerCase();
  return TAG_LABEL_VARIANTS[key] || "neutral";
}

export function mapMdbBadgeColor(color) {
  const map = {
    success: "success",
    danger: "error",
    warning: "warning",
    info: "info",
    primary: "info",
    secondary: "neutral",
    light: "neutral",
    dark: "neutral",
  };
  return map[color] || "neutral";
}

/** Shared label for order status (table + drawer). */
export function getOrderStatusDisplayLabel(order, t) {
  const loops = (order?.loops_status || "").toUpperCase().trim();
  const status = (order?.status || "").toUpperCase().trim();

  if (loops === "COMPLETED") {
    let originalLabel;
    if (status === "READY FOR DELIVERY") {
      originalLabel = t("prepared") || "Prepared";
    } else if (status === "DELIVERED") {
      originalLabel = t("DELIVERED");
    } else {
      originalLabel = t(status, status);
    }
    return `${t("COMPLETED")} (${originalLabel})`;
  }

  if (loops) return t(loops, loops);
  return t(status, status);
}
